import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { HeroLayout } from '@primer/gatsby-theme-doctocat';
import { Box, Link, Text, Label } from '@primer/react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = HeroLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <Box display="grid" gridTemplateColumns={['1fr', null, null, null]} gridGap={4} mdxType="Box">
  <Text mdxType="Text">
    Primer's interface guidelines are a collection of principles, standards, and usage guidelines for designing GitHub
    interfaces.
  </Text>
  <div>
  <div>
    <Link href="/design/guides" sx={{
            fontWeight: 'bold'
          }} mdxType="Link">
      Guides
    </Link>
    <Text as="p" mdxType="Text">Standards, guidelines, and tools to getting started with Primer.</Text>
  </div>
    <Link href="/design/foundations" sx={{
          fontWeight: 'bold'
        }} mdxType="Link">
      Foundations
    </Link>
    <Text as="p" mdxType="Text">
      The fundamental parts of the design system that underpin all GitHub interfaces, such as color and typography.
    </Text>
  </div>
  <div>
    <Link href="/design/ui-patterns" sx={{
          fontWeight: 'bold'
        }} mdxType="Link">
      UI patterns
    </Link>
    <Text as="p" mdxType="Text">Design guidelines covering common user workflows.</Text>
  </div>
  <div>
    <Link href="/design/components" sx={{
          fontWeight: 'bold'
        }} mdxType="Link">
      Components
    </Link>
    <Text as="p" mdxType="Text">Design and usage guidelines for individual Primer components.</Text>
  </div>
    </Box>
    <h2>{`Need help?`}</h2>
    <p>{`If you found a bug on this website, please `}<a parentName="p" {...{
        "href": "https://github.com/primer/design/issues/new"
      }}>{`open a new issue`}</a>{` with as much detail as possible, including steps to replicate the bug, screenshots, links, and expected results.`}</p>
    <p>{`If you need help using and designing with Primer, and you are GitHub staff, please visit the #primer Slack channel.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      